<template>
    <div class="full-wdith padding-box" v-loading="loading">
        <EditorTitle
            :showReturnBtn="true"
            :returnLabel="i18n.tkey('return')"
            :showOperationBtn="false"
            :titleLabel="i18n.tkey('lang_island_manage')"
            @clickReturnBtn="clickReturnBtn"
            v-show="viewPart === 'home' && fullScreen !== false"
        />

        <div v-if="null != companyObj" style="height: calc(100% - 65px);">
            <el-tabs
                :tab-position="tabPosition"
                type="border-card"
                style="height: 100%; box-sizing: border-box; overflow-y: auto"
            >
                <el-tab-pane :label="i18n.tkey('lang_island')">
                    <IslandEditor
                        :companyObj="companyObj"
                        @goEdit="viewPart = 'edit'"
                        @goList="viewPart = 'home'"
                    />
                </el-tab-pane>

                <el-tab-pane :label="i18n.tkey('lang_company')">
                    <CompanyEditorBackstage />
                </el-tab-pane>

                <el-tab-pane :label="i18n.tkey('lang_user')">
                    <UserEditorBackstage />
                </el-tab-pane>

                <el-tab-pane :label="i18n.tkey('lang_market')">
                    <CreatedMallEditor
                        :companyObj="companyObj"
                        :useAddBtn="false"
                    />
                </el-tab-pane>

            </el-tabs>
        </div>
    </div>
</template>

<script setup>

import {inject, getCurrentInstance, ref, toRef, onBeforeMount} from "vue";
import EditorTitle from "@/components/shopopee/common/editorTitle.vue";
import IslandEditor from "@/components/shopopee/island/islandEditor.vue";
import CompanyEditorBackstage from "@/components/shopopee/backstage/company/companyEditorBackstage.vue";
import UserEditorBackstage from "@/components/shopopee/backstage/user/userEditorBackstage.vue";
import CreatedMallEditor from "@/components/shopopee/mall/createdMallEditor.vue";
import {useUserinfo} from "@/stores/userinfo";
import companyApi from "@/request/companyApi";
import myUtil from "@/util/util";

const props = defineProps(["showReturnBtn", "fullScreen"])

const userInfoRef = toRef(useUserinfo())
const i18n = inject("i18n")
const {proxy} = getCurrentInstance()
const loading = ref(false)

const viewPart = ref("home")
const tabPosition = ref("left")

const companyObj = ref(null)

function clickReturnBtn() {
    if (viewPart.value !== "home") {
        viewPart.value = "home"
    } else {
        proxy.$router.push({name: "home"})
    }
}

function fillCompanyObj() {
    getCompanyInfo()
}

function getCompanyInfo() {
    loading.value = true

    const request = companyApi.getCompanyInfo
    const params = request.getParams()

    params.companycode = userInfoRef.value.companycode

    request.send(params, (res) => {
        loading.value = false
        if (res.code == 200) {
            const obj = res.detail

            if (null != obj.additionalrecord11 && null != obj.additionalrecord11.addremark1) {
                obj.additionalrecord11.addremark1 = JSON.parse(obj.additionalrecord11.addremark1)
            }

            companyObj.value = obj
        }
    })

}

onBeforeMount(() => {
    if (myUtil.isMobile()){
        tabPosition.value = "top"
    }

    fillCompanyObj()
})

</script>

<style scoped>
.btn-flex-box {
    display: flex;
    align-items: center;
    justify-content: center;
}

.full-wdith {
    width: 100%;
    height: 100%;
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
}

.padding-box {
    padding: 10px;
    box-sizing: border-box;
    text-align: left;
}
</style>